<template>
  <div class="animated fadeIn">
    <div class="row mb-20" v-cloak>
      <div class="col-12">
        <div class="font-bold mb-15">PT Planner</div>
        <div class="box-mini p-15 pt-20 pb-20 mb-15">
          <div class="row">
            <div class="col-md-4">
              <div class="row align-items-center">
                <div class="col-sm-3">
                  <div class="label-name">Filter by Month</div>
                </div>
                <div class="col-sm-9">
                  <input type="month" class="form-control" name="event_date" min="2000-01" v-model="dateTodayData" @change="changeDate">
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row align-items-center">
                <div class="col-sm-3">
                  <div class="label-name">Filter Branch</div>
                </div>
                <div class="col-sm-9">
                  <b-form-select name="branch" v-model="branch_id" @change="changeBranch" class="form-control">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </div>
              </div>
            </div>
            <div class="col-md-4" v-if="getRoleId == 3 || getRoleId == 4 || getRoleId == 13 || getRoleId == 17 || getRoleId == 18 || getRoleId == 27 || getRoleId == 6 || getRoleId == 8 || getRoleMappingId.includes(22)">
              <div class="row align-items-center">
                <div class="col-sm-3">
                  <div class="label-name">Personal Trainer</div>
                </div>
                <div class="col-sm-9">
                  <b-form-select name="personal_trainer" @change="changePt" v-model="pt_id" class="form-control">
                    <option :value="null" selected>Please select</option>
                    <option v-for="(item, index) in itemsPT" :key="index" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-mini mb-15">
          <div class="section-tooltip">
            <b-tooltip target="info-pt-1" placement="bottom">
              Total All Member that Owned By PT.
            </b-tooltip>
            <b-tooltip target="info-pt-2" placement="bottom">
              Member that using PT session more than 1 times.
            </b-tooltip>
            <b-tooltip target="info-pt-3" placement="bottom">
              <!-- Member that will be expired in less than 30 days. -->
              Member that will be expired in less than 14 days.
            </b-tooltip>
          </div>
          <div class="p-15 table-custom-planner table-responsive">
            <table class="border-table w-100 overflow-x">
              <thead>
                <tr>
                  <th>TOTAL MEMBER<a class="ml-10" id="info-pt-1"><i class="fas fa-exclamation-circle color-primary"></i></a></th>
                  <th>TOTAL ACTIVE MEMBER<a class="ml-10" id="info-pt-2"><i class="fas fa-exclamation-circle color-primary"></i></a></th>
                  <th>TOTAL MEMBER EXPIRED<a class="ml-10" id="info-pt-3"><i class="fas fa-exclamation-circle color-primary"></i></a></th>
                </tr>
              </thead>
              <tbody class="font-600 box-ptPlanner">
                <tr>
                  <td class="custom-part-td">
                    <!-- totalActiveMember -->
                    <button @click="showModal2('ptPlanner')" class="btn-box-ptplanner">{{dataPlannerMember1.length}}</button>
                    <b-modal modal-class="modal-custom-image" size="lg" hide-footer :ref="'ptPlanner'" centered title="Total Member">
                      <!-- <table class="w-100">
                        <thead>
                          <tr>
                            <th>Transaction ID</th>
                            <th>Name</th>
                            <th>Phone Number</th>
                            <th>Membership Type</th>
                            <th>PT Session</th>
                            <th>PT Session Expired</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(itemData1, index) in dataPlannerMember1" :key="index+'1'">
                            <td>{{itemData1.member_pt_sessions[0].trx_id}}</td>
                            <td>{{itemData1.first_name ? itemData1.first_name : ''}} {{itemData1.last_name}}</td>
                            <td>{{itemData1.phone_number}}</td>
                            <td>{{itemData1.membership_last_buy_name}}</td>
                            <td>{{(itemData1.member_pt_sessions && itemData1.member_pt_sessions[0] ? itemData1.member_pt_sessions[0].current_session_qty + ' of ' + itemData1.member_pt_sessions[0].buy_session_qty : '-')}}</td>
                            <td>{{(itemData1.member_pt_sessions && itemData1.member_pt_sessions[0] ? (itemData1.member_pt_sessions[0].expired_at) : '-')}}</td>
                          </tr>
                        </tbody>
                      </table> -->
                    <table class="w-100">
                        <thead>
                          <tr>
                            <th>Transaction ID</th>
                            <th>Name</th>
                            <th>Phone Number</th>
                            <th>Membership Type</th>
                            <th>PT Session</th>
                            <th>PT Session Expired</th>
                            <th>Personal Training</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(itemData1, index) in dataPlannerMember1" :key="index+'1'">
                            <td>{{itemData1.trx_id}}</td>
                            <td>{{itemData1.member.first_name}} {{itemData1.member.last_name}}</td>
                            <td>{{itemData1.member.phone_number}}</td>
                            <td>{{itemData1.member.membership_last_buy_name}}</td>
                            <td>{{(itemData1.current_session_qty + ' of ' + itemData1.buy_session_qty )}}</td>
                            <td>{{((itemData1.expired_at))}}</td>
                            <td>{{((itemData1.personal_training.name))}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </b-modal>
                  </td>
                  <td class="custom-part-td">
                    <!-- ptPlannerStatistic.total_active_member -->
                    <button @click="showModal2('total_active_member')" class="btn-box-ptplanner">{{dataPlannerMember2.length}}</button>
                    <b-modal modal-class="modal-custom-image" size="lg" hide-footer :ref="'total_active_member'" centered title="Total Active Member">
                      <table class="w-100">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone Number</th>
                            <th>Membership Type</th>
                            <th>PT Session</th>
                            <th>PT Session Expired</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(itemData2, index) in dataPlannerMember2" :key="index+'2'">
                            <td>{{itemData2.first_name ? itemData2.first_name : ''}} {{itemData2.last_name}}</td>
                            <td>{{itemData2.email}}</td>
                            <td>{{itemData2.phone_number}}</td>
                            <td>{{itemData2.membership_last_buy_name}}</td>
                            <td>{{(itemData2.member_pt_sessions && itemData2.member_pt_sessions[0] ? itemData2.member_pt_sessions[0].current_session_qty + ' of ' + itemData2.member_pt_sessions[0].buy_session_qty : '-')}}</td>
                            <td>{{(itemData2.member_pt_sessions && itemData2.member_pt_sessions[0] ? (itemData2.member_pt_sessions[0].expired_at) : '-')}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </b-modal>
                  </td>
                  <td class="custom-part-td">
                    <button @click="showModal2('total_member_expired')" class="btn-box-ptplanner">{{ptPlannerStatistic.total_member_expired}}</button>
                    <b-modal modal-class="modal-custom-image" size="lg" hide-footer :ref="'total_member_expired'" centered title="Total Member Expired">
                      <table class="w-100">
                        <thead>
                          <tr>
                            <th>TRX ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone Number</th>
                            <th>Membership Type</th>
                            <th>PT Session</th>
                            <th>PT Session Expired</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(itemData3, index) in dataPlannerMember3" :key="index+'3'">
                            <td>{{itemData3.trx_id}}</td>
                            <td>{{itemData3.member && itemData3.member.first_name ? itemData3.member.first_name + ' ' + itemData3.member.last_name : '-'}}</td>
                            <td>{{itemData3.member ? itemData3.member.email : '-'}}</td>
                            <td>{{itemData3.member ? itemData3.member.phone_number : '-'}}</td>
                            <td>{{itemData3.member ? itemData3.member.membership_last_buy_name : '-'}}</td>
                            <td>{{itemData3.current_session_qty}} of {{itemData3.buy_session_qty}}</td>
                            <td>{{itemData3.expired_at}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </b-modal>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="box-mini mb-15">
          <div class="p-15 table-custom-planner table-responsive">
            <table class="border-table w-100 overflow-x">
              <thead>
                <tr>
                  <th></th>
                  <th v-for="(item, index) in plannerActivity" :key="index">
                    {{item.name}}
                  </th>
                </tr>
              </thead>
              <tbody class="font-600">
                <tr v-if="valueActivity.length">
                  <td>TOTAL</td>
                  <!-- <td>{{filterActivity(1)}}</td> -->
                  <!-- PHA SHOW -->
                  <td class="row-php-apointment">
                    <button @click="showModal2('detail_pha_show')" class="btn-php-apointment">{{filterActivity(1)}}</button>
                    <b-modal modal-class="modal-custom-image" size="lg" hide-footer :ref="'detail_pha_show'" centered title="PHA SHOW">
                      <table class="w-100">
                        <thead>
                          <tr>
                            <th>Personal Trainer</th>
                            <th>Member</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(itemData1, index) in dataPlannerPHAshow" :key="index+'1'">
                            <td>{{itemData1["personal_training.name"]}}</td>
                            <td v-if="itemData1['member'] == null || itemData1['member'] == ' '"> - </td>
                            <td v-if="itemData1['member'] != null && itemData1['member'] != ' '">{{itemData1["member"]}}</td>
                            <td>{{itemData1["date"]}}</td>
                          </tr>
                        </tbody>
                      </table>
                     </b-modal>
                  </td>
                  <!-- <td>{{filterActivity(2)}}</td> -->
                  <!-- PHP APOINTMENT -->
                  <td class="row-php-apointment">
                    <button @click="showModal2('detail_php_appointment')" class="btn-php-apointment">{{filterActivity(2)}}</button>
                     <b-modal modal-class="modal-custom-image" size="lg" hide-footer :ref="'detail_php_appointment'" centered title="PHA Appointment">
                      <table class="w-100">
                        <thead>
                          <tr>
                            <th>Personal Trainer</th>
                            <th>Member</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(itemData1, index) in dataPlannerPHAappointment" :key="index+'1'">
                            <td>{{itemData1["personal_training.name"]}}</td>
                            <td v-if="itemData1['member'] == null || itemData1['member'] == ' '"> - </td>
                            <td v-if="itemData1['member'] != null && itemData1['member'] != ' '">{{itemData1["member"]}}</td>
                            <td>{{itemData1["date"]}}</td>
                          </tr>
                        </tbody>
                      </table>
                     </b-modal>
                  </td>
                  <td>{{filterActivity(3)}}</td>
                  <td>{{filterActivity(4)}}</td>
                  <td>{{filterActivity(5)}}</td>
                  <td>{{filterActivity(6)}}</td>
                  <td>{{filterActivity(7)}}</td>
                  <td>{{filterActivity(8)}}</td>
                  <td>{{filterActivity(9)}}</td>
                  <td>{{filterActivity(10)}}</td>
                  <td>{{filterActivity(11)}}</td>
                  <td>{{filterActivity(12)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="box-mini mb-15">
          <div class="p-15 table-custom-planner table-responsive">
            <table class="border-table w-100 overflow-x">
              <thead>
                <tr>
                  <th></th>
                  <th v-for="(item, index) in plannerActivity2" :key="index">
                    {{item.name}}
                  </th>
                </tr>
              </thead>
              <tbody class="font-600">
                <tr v-if="valueActivity.length">
                  <td>TOTAL</td>
                  <td>{{filterActivity(13)}}</td>
                  <td>{{filterActivity(14)}}</td>
                  <td>{{filterActivity(15)}}</td>
                  <td>{{filterActivity(16)}}</td>
                  <td>{{filterActivity(17)}}</td>
                  <td>{{filterActivity(18)}}</td>
                  <td>{{filterActivity(19)}}</td>
                  <td>{{filterActivity(20)}}</td>
                  <td>{{filterActivity(21)}}</td>
                  <td>{{filterActivity(22)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="box-mini">
          <div class="p-15 table-responsive">
            <table class="table-level-1 w-100 overflow-x" cellspacing="0" cellpadding="0">
              <tbody>
                <tr v-for="(loopWeek, index) in 5" :key="index+'week'">
                  <td class="week">Week {{loopWeek}}</td>
                  <td>
                    <table class="table-level-2" cellspacing="0" cellpadding="0">
                      <tr>
                        <td v-for="(itemData, index) in combineName(loopWeek)" :key="index+'core'">
                          <div class="head-title row row-custom-0 font-600">
                            <div class="col-6 col-custom-0">{{getNameDay(itemData.date)}}</div>
                            <div class="col-6 col-custom-0 text-right">{{getDay(itemData.date)}} {{getMonth(itemData.date)}}</div>
                          </div>

                          <!-- set blocking full day -->
                          <div v-if="blockFullDay(itemData)">
                            <template v-for="rowTime in itemData.time">
                              <div class="body-time row row-custom-0" :class="{'opacity-04-blockFullDay' : true }" :key="rowTime.id" v-if="rowTime.id != 17">
                                <div class="box-off" v-if="compareDate(itemData.date)"></div>
                                <div class="col-5 col-custom-0">
                                  <span>{{ cutTime(rowTime.time_start) }} - {{ cutTime(rowTime.time_end) }}</span>
                                </div>
                                <div class="col-7 custom-manipulator col-custom-0 text-right">
                                  <a
                                    :key="rowTime.id + 'addPlanner'"
                                    @click="openPage('/ptPlanner/add?date=' + getFullDate(itemData.date) + '&planner_time=' + rowTime.id + '&pt_id=' + current_pt_id + '&branch_id=' + current_branch_id)"
                                    class="mr-10 color-primary btn-add-planner">
                                    <i class="fas fa-plus"></i>
                                  </a>
                                </div>
                                <div class="col-12 col-custom-0 mb-2">
                                  <div class="detail-data mb-2">
                                    <div v-for="(rowData, index) in rowTime.activity" :key="index+'asd'">
                                      <div v-if="rowData.length != 0 && rowData.member_id != 0">
                                        {{rowData.member ? rowData.member.first_name + ' ' + rowData.member.last_name: rowData.lead ? rowData.lead.name : ''}}
                                      </div>
                                      <div v-else>
                                        Personal Trainer
                                      </div>
                                      <div class="row" v-if="rowData.length != 0">
                                        <div class="col-10" v-if="rowData.pt_planner_activity_id != 0">
                                          {{rowData.pt_planner_activity.name}}
                                        </div>
                                        <div class="col-2 pl-0">
                                          <a
                                            :key="rowData.id + 'editPlanner'"
                                            @click="openPage('/ptPlanner/edit?planner_id=' + rowData.id + '&pt_id=' + rowData.personal_trainer_id)"
                                            class="color-primary btn-edit-planner">
                                            <i class="fas fa-pencil-alt"></i>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="footer-leave" :class="{'box-off-footer' : compareDate(itemData.date) ? true : false}" :key="rowTime.id + 'footer'" v-else>
                                <a
                                  v-if="!rowTime.activity && rowTime.id == 17"
                                  class="color-primary btn-leave-edit"
                                  :class="{'btn-leave off' : (getRoleId == 3 || getRoleId == 4 || getRoleId == 13) ? ((pt_id ? false : false) ? false : true) : false}"
                                  @click="openPage('/ptPlanner/editPlannerLeave?date=' + getFullDate(itemData.date) + '&planner_id=' + rowTime.pt_planner_id + '&branch_id=' + current_branch_id)">
                                    <i class="far fa-edit mr-5"></i>Action
                                </a>
                                <a v-if="itemData.empty_activity_status === true"
                                @click="openPage('/ptPlanner/addPlannerLeave?pt_id='+ itemData.personal_trainer_id +'&date=' + getFullDate(itemData.date) + '&branch_id=' + current_branch_id)"
                                class="btn-leave color-primary"
                                :class="{'off' : (getRoleId == 3 || getRoleId == 4 || getRoleId == 13) ? ((pt_id ? false : false) ? false : true) : false}">
                                <i class="far fa-plus-square mr-5"></i>Action
                                </a>
                                <a v-if="itemData.empty_activity_status === false" class="color-primary btn-leave off">
                                  <i class="fas fa-ban mr-5"></i>Action
                                </a>
                              </div>
                            </template>
                          </div>

                          <!-- set non Blocking full day -->
                          <div v-else>
                            <template v-for="rowTime in itemData.time">
                                <div class="body-time row row-custom-0" :class="{'opacity-04' : compareDate(itemData.date) ? true : false}" :key="rowTime.id" v-if="rowTime.id != 17">
                                  <div class="box-off" v-if="compareDate(itemData.date)"></div>
                                  <div class="col-5 col-custom-0">
                                    <span>{{ cutTime(rowTime.time_start) }} - {{ cutTime(rowTime.time_end) }}</span>
                                  </div>
                                  <div class="col-7 custom-manipulator col-custom-0 text-right">
                                    <a
                                      :key="rowTime.id + 'addPlanner'"
                                      @click="openPage('/ptPlanner/add?date=' + getFullDate(itemData.date) + '&planner_time=' + rowTime.id + '&pt_id=' + current_pt_id + '&branch_id=' + current_branch_id)"
                                      class="mr-10 color-primary btn-add-planner">
                                      <i class="fas fa-plus"></i>
                                    </a>
                                  </div>
                                  <div class="col-12 col-custom-0 mb-2">
                                    <div class="detail-data mb-2">
                                      <div v-for="(rowData, index) in rowTime.activity" :key="index+'asd'">
                                        <div v-if="rowData.length != 0 && rowData.member_id != 0">
                                          {{rowData.member ? rowData.member.first_name + ' ' + rowData.member.last_name: rowData.lead ? rowData.lead.name : ''}}
                                        </div>
                                        <div v-else>
                                          Personal Trainer
                                        </div>
                                        <div class="row" v-if="rowData.length != 0">
                                          <div class="col-10" v-if="rowData.pt_planner_activity_id != 0">
                                            {{rowData.pt_planner_activity.name}}
                                          </div>
                                          <div class="col-2 pl-0">
                                            <a
                                              :key="rowData.id + 'editPlanner'"
                                              @click="openPage('/ptPlanner/edit?planner_id=' + rowData.id + '&pt_id=' + rowData.personal_trainer_id)"
                                              class="color-primary btn-edit-planner">
                                              <i class="fas fa-pencil-alt"></i>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="footer-leave" :class="{'box-off-footer' : compareDate(itemData.date) ? true : false}" :key="rowTime.id + 'footer'" v-else>
                                  <a
                                    v-if="!rowTime.activity && rowTime.id == 17"
                                    class="color-primary btn-leave-edit"
                                    :class="{'btn-leave off' : (getRoleId == 3 || getRoleId == 4 || getRoleId == 13) ? ((pt_id ? false : false) ? false : true) : false}"
                                    @click="openPage('/ptPlanner/editPlannerLeave?date=' + getFullDate(itemData.date) + '&planner_id=' + rowTime.pt_planner_id) + '&branch_id=' + current_branch_id">
                                      <i class="far fa-edit mr-5"></i>Action
                                  </a>
                                  <a v-if="itemData.empty_activity_status === true"
                                  @click="openPage('/ptPlanner/addPlannerLeave?pt_id='+ itemData.personal_trainer_id +'&date=' + getFullDate(itemData.date) + '&branch_id=' + current_branch_id)"
                                  class="btn-leave color-primary"
                                  :class="{'off' : (getRoleId == 3 || getRoleId == 4 || getRoleId == 13) ? ((pt_id ? false : false) ? false : true) : false}">
                                  <i class="far fa-plus-square mr-5"></i>Action
                                  </a>
                                  <a v-if="itemData.empty_activity_status === false" class="color-primary btn-leave off">
                                    <i class="fas fa-ban mr-5"></i>Action
                                  </a>
                                </div>
                            </template>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="">
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'
import { ModelSelect } from 'vue-search-select'
import { constants } from 'zlib';

export default {
  name: 'leads',
  components: {
    ModelSelect,
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dataBranch: [],
      current_branch_id: null,
      branch_id: null,
      current_pt_id: null,
      loadingActive: false,
      getRoleId: Auth.Session.get().paradigm_role,
      getID: Auth.Session.get().paradigm_id,
      getRoleMappingId: Auth.Session.get().paradigm_role_mapping_id,
      pt_id: null,
      current_pt_name: null,
      itemsPT: [],
      totalActiveMember: '',
      dateTodayData: moment(new Date()).format('YYYY-MM'),
      dataActivity: [],
      config: {
        altInput: true,
        altFormat: 'F Y',
        dateFormat: 'Y-m-d'
      },
      addPlanner: {
        personal_trainer_id: '',
        pt_planner_activity_id: null,
        date: '',
        pt_planner_time_id: 0,
        member_id: 0
      },
      ptPlannerStatistic: {},
      dataPlannerMember1: [],
      dataPlannerMember2: [],
      dataPlannerMember3: [],
      dataPlannerPHAappointment: [],
      dataPlannerPHAshow: [],
      planner_id: '',
      planner_leave_id: '',
      status_planner: null,
      checkData: '',
      member_name: null,
      plannerActivity: [],
      plannerActivity2: [],
      dataBranch: [],
      branch_id: null,
      listMember: [],
      itemTime: [],
      listData: [],
      listDataLeave: [],
      listDataNew1: [],
      listDataNew2: [],
      listDataNew3: [],
      listDataNew4: [],
      listDataNew5: [],
      listData_length: null,
      optionsMember: [
        { value: 0, text: 'Please select' }
      ],
      currentTotalDay: moment(new Date(), "YYYY-MM").daysInMonth(),
      currentNumberMonth: moment(new Date()).format('M'),
      currentNumberYear: moment(new Date()).format('YYYY'),
      valueActivity: [],
    }
  },
  methods: {
    blockFullDay(data) {
      // console.log(data)
      for (let i = 0; i < data.time.length; i++) {
        if (data.time[i].activity.length != 0) {
          for (let d = 0; d < data.time[i].activity.length; d++) {
            console.log(data.time[i].activity[d].pt_planner_activity_id)
            if (data.time[i].activity[d].pt_planner_activity_id == 13 || data.time[i].activity[d].pt_planner_activity_id == 14 || data.time[i].activity[d].pt_planner_activity_id == 15 || data.time[i].activity[d].pt_planner_activity_id == 16) {
              return true
            } else {
              return false
            }
          }
        }
      }
    },
    compareDate (value) {
      var rowDate = moment(value).format("YYYY-MM-DD")
      var today = moment(new Date()).format("YYYY-MM-DD")
      if(rowDate < today) {
        return true
      }
    },
    getActivityName (item, id) {
      let tmp = item.filter(row => {
        if (row.id === 17 && row.pt_planner_activity_id != 0) return row
        else if (row.pt_planner_activity_id != 0) return row
      })

      if (tmp.length == 1 && tmp[0].id == 17) {
        return tmp[0].pt_planner_activity.name
      } else if (tmp.length) {
        let activity = item.filter(row => row.id == id)
        return activity[0].pt_planner_activity ? activity[0].pt_planner_activity.name : ''
      }

      return ''
    },
    isDisable (item, row) {
      let isLeave = item.filter(time => time.id == 17 & time.pt_planner_activity_id != 0)
      if (isLeave.length) return true

      if (row.pt_planner_activity_id != 0) return true
      else if (row.pt_planner_activity_id == 0) return false
    },
    combineName (event) {
      if(event == 1) {
        return this.listDataNew1
      }
      if(event == 2) {
        return this.listDataNew2
      }
      if(event == 3) {
        return this.listDataNew3
      }
      if(event == 4) {
        return this.listDataNew4
      }
      if(event == 5) {
        return this.listDataNew5
      }
    },
    toMonth (value) {
      return moment(new Date(value)).format('M')
    },
    filterActivity(event) {
      // if(init===1){
      //   return this.valueActivity[event-1].value
      // }else{
      //   return (this.listData.filter(item => (item.pt_planner_activity && item.pt_planner_activity.id === event) && this.toMonth(item.date) == this.currentNumberMonth)).length
      // }
      return this.valueActivity[event-1].value
    },
    ifPlannerMember (event) {
      if (event === 1 || event === 2 || event === 3 || event === 4 || event === 5 || event === 6) {
        return true
      } else {
        return false
      }
    },
    ifTrueData (data2, data4, data5) {
      for(var i = 0; this.listData.length ; i++) {
        if(this.whichWeek(this.listData[i].date) == data2 && this.listData[i].pt_planner_time.id == data4 && this.getFullDate(this.listData[i].date) == this.getFullDate(data5)) {
          return true
        } else {
          return false
        }
      }
    },
    ifTrueBtnLeave (data1, data2, data5) {
      if(this.whichWeek(data1) == data2 && this.getFullDate(data1) == this.getFullDate(data5)) {
        return true
      } else {
        return false
      }
    },
    ifTrueBtnLeaveEdit (data1, data2, data3, data5) {
      if(this.whichWeek(data1) == data2 && this.getFullDate(data1) == this.getFullDate(data5) && data3 == 17) {
        return true
      } else {
        return false
      }
    },
    ifTrueCondition (data1, data2, data3, data4, data5) {
      if(this.whichWeek(data1) == data2 && data3 == data4 && this.getFullDate(data1) == this.getFullDate(data5)) {
        return true
      } else {
        return false
      }
    },
    ifTrueCondition2 (data1, data2, data3, data5) {
      if(this.whichWeek(data1) == data2 && data3 == 17 && this.getFullDate(data1) == this.getFullDate(data5)) {
        return true
      } else {
        return false
      }
    },
    changeDate (event) {
      this.loadingActive = true
      this.currentNumberMonth = moment(new Date(this.dateTodayData)).format('M')
      this.fetchData()
      this.initFetch()
    },
    cutTime(value) {
      return (value).slice(0, -3)
    },
    deleteData(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.delete('crm/v1/leads/' + event).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    statusMembership (status) {
      return (status === 'Active') ? 'success'
          : (status === 'Terminated') ? 'danger'
          : (status === 'Canceled') ? 'danger'
          : (status === 'Outstanding') ? 'danger' : 'warning'
    },
    openPage (event) {
      this.$router.push(event)
    },
    getWeek (date) {
        var prefixes = ['1', '2', '3', '4', '5']
        return prefixes[Math.ceil(date.getDate() / 7)]
    },
    whichWeek (value) {
      // return moment(new Date()).format('YYYY WWWW MMMM')
      var dateNew = moment(new Date(value)).format('YYYY-MM-DD')
      // var year = moment(new Date()).format('YYYY')
      // var month_number = moment(new Date()).format('M')
      let week = this.getWeek(new Date(dateNew))
      return week

    },
    getYearMonth (value) {
      return moment(new Date(value)).format('YYYY-MM')
    },
    getFullDate (value) {
      return moment(new Date(value)).format('YYYY-MM-DD')
    },
    todayNumber () {
      return moment().isoWeekday()
    },
    getNameDay (value) {
      moment.locale('en')
      return moment(new Date(value)).format('dddd')
    },
    getDay (value) {
      moment.locale('en')
      return moment(new Date(value)).format('D')
    },
    getMonth (value) {
      return moment(new Date(value)).format('MMM')
    },
    getYear (value) {
      return moment(new Date(value)).format('YYYY')
    },
    getNumberDayInWeek (value) {
      return moment(new Date(value)).isoWeekday()
    },
    parseDateTime3 (value) {
      var curr = new Date
      var first = curr.getDate() - curr.getDay()
      var monthName = new Date(curr.getTime())
      moment.locale('en')
      return moment(new Date(monthName)).format('MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'crm/v1/img/banner/' + value
    },
    getDaysInMonth(month, year) {
        var date = new Date(year + '-' + month + '-1')
        var days = []
        while (date.getMonth() === month) {
            days.push(new Date(date))
            date.setDate(date.getDate() + 1)
        }
        return days
    },
    showModal2 (id, date, pt_planner_time_id) {
      this.$refs[id].show()
    },
    showModal (id, date, pt_planner_time_id) {
      this.$refs[id].show()
      this.addPlanner.date = date
      this.addPlanner.pt_planner_time_id = pt_planner_time_id
    },
    showModalEdit (event, planner_id) {
      this.planner_id = planner_id
      // var data = this.listData.filter(item => item.id === planner_id)
      axios.get('crm/v1/pt_planner/' + planner_id).then(response => {
        this.addPlanner = response.data.data
      }).catch(error => {
        console.log('error', error)
      })
      this.$refs[event].show()
    },
    showModalLeave (event, fullDate) {
      this.$refs[event].show()
      this.addPlanner.date = fullDate
      this.addPlanner.pt_planner_time_id = 17
    },
    showModalLeaveEdit (event, fullDate, id) {
      this.$refs[event].show()
      this.addPlanner.date = fullDate
      this.addPlanner.pt_planner_time_id = 17
      this.planner_leave_id = id
      axios.get('crm/v1/pt_planner/' + id).then(response => {
        this.addPlanner.pt_planner_activity_id = response.data.data.pt_planner_activity_id
      }).catch(error => {
        console.log('error', error)
      })
    },
    hideModal (id) {
      this.$refs[id].hide()
      this.addPlanner.pt_planner_activity_id = null
      this.addPlanner.date = ''
      this.addPlanner.pt_planner_time_id = 0
      this.addPlanner.member_id = 0
    },
    changePt() {
      this.loadingActive = true
      this.current_pt_id = this.pt_id
      this.fetchData()
      this.initFetch()
    },
    changeBranch() {
      this.pt_id = null
      this.loadingActive = true
      this.current_branch_id = this.branch_id
      this.fetchData()
      this.initFetch()
    },
    refreshBranch() {
      this.loadingActive = true
      this.current_branch_id = this.branch_id
      this.fetchData()
      this.initFetch()
    },
    fetchData() {
      // get Branch
      axios.get('fitness/v1/branch/').then(response => {
        if (this.$router.currentRoute.fullPath != '/ptPlanner') {
          this.$router.replace('/ptPlanner')
        }
        this.dataBranch = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
      // turn off autocomplete
      if(document.getElementsByTagName) {
        var inputElements = document.getElementsByTagName("member_id")
        for (var i=0; inputElements[i]; i++) {
          if (inputElements[i].className && (inputElements[i].className.indexOf("disableAutoComplete") != -1)) {
            inputElements[i].setAttribute("autocomplete","off")
          }
        }
      }
      axios.get('crm/v1/pt_planner_time?sorting=id&sorting_type=asc').then(response => {
        // this.itemTime = response.data.data.rows
        var dataTime = [...response.data.data.rows]

        var getLength = dataTime.length
        dataTime.splice(getLength - 1, 1)
        this.itemTime = dataTime
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/pt_planner_activity?sorting=id&sorting_type=asc').then(response => {
        this.dataActivity = response.data.data.rows
        var data1 = [...response.data.data.rows]
        var data2 = [...response.data.data.rows]

        var getLength = data1.length
        data1.splice(getLength - 5, 5)
        this.plannerActivity = data1
        data2.splice(0, 12)
        var data3 = [...data2]
        data3.splice(data2.length - 1, 1)
        this.plannerActivity2 = data3
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/member/data_entry').then(response => {
        this.listMember = response.data.data.rows
        for (var i = 0; i < this.listMember.length; i++) {
          let memberBranchId
          if(!this.listMember[i].branch_id) {
            memberBranchId = '(FT-' + this.listMember[i].id + ') ' + this.listMember[i].first_name + ' ' + this.listMember[i].last_name
          } else {
            memberBranchId = '(' + this.listMember[i].branch.codename + '-' + this.listMember[i].id + ') ' + this.listMember[i].first_name + ' ' + this.listMember[i].last_name
          }
          // var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: this.listMember[i].id, text: this.listMember[i].first_name + ' ' + this.listMember[i].last_name})
          var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: this.listMember[i].id, text: memberBranchId})
          this.optionsMember.push(dataComplete)
        }
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc&branch_id='+this.current_branch_id).then(response => {
        this.itemsPT = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      if(Auth.Session.get().paradigm_role == 3 || Auth.Session.get().paradigm_role == 4 || Auth.Session.get().paradigm_role == 13 || Auth.Session.get().paradigm_role == 17 || Auth.Session.get().paradigm_role == 18 || Auth.Session.get().paradigm_role == 27 || this.getRoleMappingId.includes(22)) {
        axios.get('crm/v1/pt_planner?personal_trainer_id=' + this.pt_id + '&date=' + this.dateTodayData + '&branch_id=' + this.branch_id).then(response => {
          this.listData = response.data.data.rows
          var newArray = [...response.data.data.rows]
          this.listDataLeave = newArray.filter(function({date}) {
            return !this[date] && (this[date] = date)
          }, {})
          this.loadingActive = false
          // this.listDataLeave = newArray
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/pt_planner/multiple_activity_pt_planner?personal_trainer_id=' + this.pt_id + '&date=' + this.dateTodayData + '&week=1' + '&branch_id=' + this.branch_id).then(response => {
          this.listDataNew1 = response.data
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/pt_planner/multiple_activity_pt_planner?personal_trainer_id=' + this.pt_id + '&date=' + this.dateTodayData + '&week=2' + '&branch_id=' + this.branch_id).then(response => {
          this.listDataNew2 = response.data
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/pt_planner/multiple_activity_pt_planner?personal_trainer_id=' + this.pt_id + '&date=' + this.dateTodayData + '&week=3' + '&branch_id=' + this.branch_id).then(response => {
          this.listDataNew3 = response.data
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/pt_planner/multiple_activity_pt_planner?personal_trainer_id=' + this.pt_id + '&date=' + this.dateTodayData + '&week=4' + '&branch_id=' + this.branch_id).then(response => {
          this.listDataNew4 = response.data
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/pt_planner/multiple_activity_pt_planner?personal_trainer_id=' + this.pt_id + '&date=' + this.dateTodayData + '&week=5' + '&branch_id=' + this.branch_id).then(response => {
          this.listDataNew5 = response.data
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/pt_planner_statistic?personal_trainer_id=' + this.pt_id + '&date='+this.dateTodayData + '&branch_id=' + this.branch_id).then(response => {
          this.ptPlannerStatistic = response.data
          // console.log('test', response.data)
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('fitness/v1/personal_training/my_member?pt_id=' + this.pt_id + '&date='+this.dateTodayData + '&branch_id=' + this.branch_id).then(response => {
          // this.dataPlannerMember1 = response.data.data.rows
          let column = 'personal_training'
          let sort = response.data.data.rows.sort((a,b) => (a[column]['name'] || "").toString().localeCompare((b[column]['name'] || "").toString()))
          this.dataPlannerMember1 = sort
          // this.totalActiveMember = (response.data.data.rows).length
          this.totalActiveMember = response.data.data.count
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/pt_planner_statistic/active_member?personal_trainer_id=' + this.pt_id + '&date='+this.dateTodayData + '&branch_id=' + this.branch_id).then(response => {
          this.dataPlannerMember2 = response.data.data.rows
          // console.log('test', response.data)
        }).catch(error => {
          console.log('error', error)
        })
        // Get detail PHP Appointment data
        axios.get('crm/v1/pt_planner/php-appointment/detail?pt_id=' + this.pt_id + '&date='+this.dateTodayData + '&branch_id=' + this.branch_id).then(response => {
          this.dataPlannerPHAappointment = response.data.data.rows
          console.log('PHA', response.data)
        }).catch(error => {
          console.log('error', error)
        })
        // END PHA
        // Get detail PHA SHOW data
        axios.get('crm/v1/pt_planner/pha-show/detail?pt_id=' + this.pt_id + '&date='+this.dateTodayData + '&branch_id=' + this.branch_id).then(response => {
          this.dataPlannerPHAshow = response.data.data.rows
          console.log('PHA SHOW', response.data)
        }).catch(error => {
          console.log('error', error)
        })
        // END PHA SHOW
        axios.get('crm/v1/pt_planner_statistic/member_expired?personal_trainer_id=' + this.pt_id + '&date='+this.dateTodayData + '&branch_id=' + this.branch_id).then(response => {
          this.dataPlannerMember3 = response.data.data.rows
          // console.log('test', response.data)
        }).catch(error => {
          console.log('error', error)
        })

        let url_branch = `fitness/v1/branch?paradigm_id=${this.getID}&paradigm_role_id=${this.getRoleId}`
        axios
          .get(url_branch)
          .then((response) => {
            this.dataBranch = response.data.data.rows;
          })
          .catch((error) => {
            console.log("error", error);
          });
      } else {
        axios.get('crm/v1/pt_planner?personal_trainer_id=' + Auth.Session.get().paradigm_id + '&date=' + this.dateTodayData + '&branch_id=' + this.branch_id).then(response => {
          this.listData = response.data.data.rows
          var newArray = [...response.data.data.rows]
          this.listDataLeave = newArray.filter(function({date}) {
            return !this[date] && (this[date] = date)
          }, {})
          this.listDataLeave = newArray
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/pt_planner/multiple_activity_pt_planner?personal_trainer_id=' + Auth.Session.get().paradigm_id + '&date=' + this.dateTodayData + '&week=1' + '&branch_id=' + this.branch_id).then(response => {
          this.listDataNew1 = response.data
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/pt_planner/multiple_activity_pt_planner?personal_trainer_id=' + Auth.Session.get().paradigm_id + '&date=' + this.dateTodayData + '&week=2' + '&branch_id=' + this.branch_id).then(response => {
          this.listDataNew2 = response.data
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/pt_planner/multiple_activity_pt_planner?personal_trainer_id=' + Auth.Session.get().paradigm_id + '&date=' + this.dateTodayData + '&week=3' + '&branch_id=' + this.branch_id).then(response => {
          this.listDataNew3 = response.data
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/pt_planner/multiple_activity_pt_planner?personal_trainer_id=' + Auth.Session.get().paradigm_id + '&date=' + this.dateTodayData + '&week=4' + '&branch_id=' + this.branch_id).then(response => {
          this.listDataNew4 = response.data
          this.loadingActive = false
          // console.log(this.listDataNew4)
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/pt_planner/multiple_activity_pt_planner?personal_trainer_id=' + Auth.Session.get().paradigm_id + '&date=' + this.dateTodayData + '&week=5' + '&branch_id=' + this.branch_id).then(response => {
          this.listDataNew5 = response.data
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/pt_planner_statistic?personal_trainer_id=' + Auth.Session.get().paradigm_id + '&date='+this.dateTodayData + '&branch_id=' + this.branch_id).then(response => {
          this.ptPlannerStatistic = response.data
          // console.log('test', response.data)
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('fitness/v1/personal_training/my_member?pt_id=' + Auth.Session.get().paradigm_id + '&date='+this.dateTodayData + '&branch_id=' + this.branch_id).then(response => {
          // this.dataPlannerMember1 = response.data.data.rows
          let column = 'personal_training'
          let sort = response.data.data.rows.sort((a,b) => (a[column]['name'] || "").toString().localeCompare((b[column]['name'] || "").toString()))
          this.dataPlannerMember1 = sort
          this.totalActiveMember = (response.data.data.rows).length
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/pt_planner_statistic/active_member?personal_trainer_id=' + Auth.Session.get().paradigm_id + '&date='+this.dateTodayData + '&branch_id=' + this.branch_id).then(response => {
          this.dataPlannerMember2 = response.data.data.rows
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/pt_planner_statistic/member_expired?personal_trainer_id=' + Auth.Session.get().paradigm_id + '&date='+this.dateTodayData + '&branch_id=' + this.branch_id).then(response => {
          this.dataPlannerMember3 = response.data.data.rows
        }).catch(error => {
          console.log('error', error)
        })

        let url_branch = `fitness/v1/branch?paradigm_id=${this.getID}&paradigm_role_id=${this.getRoleId}`
        axios
          .get(url_branch)
          .then((response) => {
            this.dataBranch = response.data.data.rows;
          })
          .catch((error) => {
            console.log("error", error);
          });
      }
    },
    initFetch(){
      console.log("Auth Session : ",Auth.Session.get())
      let personal_trainer_id = (Auth.Session.get().paradigm_role == 7) ? Auth.Session.get().paradigm_id : this.pt_id
      axios.get('crm/v1/pt_planner_statistic/activity?personal_trainer_id=' + personal_trainer_id + '&date=' + this.dateTodayData + '&branch_id=' + this.branch_id).then(response => {
          var dataKeys = Object.keys(response.data)
          var dataVals = Object.values(response.data)
          var dataLength = dataKeys.length
          var arr = []
          for(var i=0;i<dataLength;i++){
            var data = {name: dataKeys[i], value: dataVals[i]}
            Object.assign({}, data)
            arr.push(data)
          }
          this.valueActivity = arr
          var data1 = [...arr]
          var data2 = [...arr]
          data2.splice(0, 12)
          data1.splice(arr.length - 9, 9)
          this.plannerActivity = data1
          this.plannerActivity2 = data2
        }).catch(error => {
          console.log('error', error)
        })
    }
  },
  mounted () {
    this.branch_id = this.$route.query.branch_id == undefined ? null : this.$route.query.branch_id
     this.pt_id = this.$route.query.pt_id == undefined ? null : this.$route.query.pt_id
     this.refreshBranch()
     this.changePt()

    this.addPlanner.personal_trainer_id = Auth.Session.get().paradigm_id
    if(Auth.Session.get().paradigm_role == 3 || Auth.Session.get().paradigm_role == 4 || Auth.Session.get().paradigm_role == 13 || Auth.Session.get().paradigm_role == 27 || this.getRoleMappingId.includes(22)) {
      this.current_pt_id = this.pt_id
    } else {
      this.current_pt_id = Auth.Session.get().paradigm_id
    }
    this.fetchData()
    this.initFetch()
  }
}
</script>

<style>
[v-cloak] {
  display: none;
}
</style>
